import { useDispatch } from "react-redux";
import * as AC from "./actionCreators";
import { BugModalInvoker, ErrorData } from "./types";
import { submitBugReport } from "./thunkCreators";
import { makeErrorEntity } from "../../utils/generalUtils";

export const useCloseBugReportModalCallback = () => {
  const dispatch = useDispatch();
  return () => dispatch(AC.closeBugReportModal());
};

export const useInvokeBugReportModalCallback = (invoker: BugModalInvoker) => {
  const dispatch = useDispatch();
  return (errorData?: ErrorData | ErrorData[]) => {
    const now = new Date().toISOString();

    const payload = {
      error: errorData ? makeErrorEntity(invoker, errorData) : undefined,
      invoker,
      time: now,
    };
    dispatch(AC.invokeBugReportModal(payload));
  };
};

export const useCommonInvokeBugReportModalCallback = () => {
  const dispatch = useDispatch();
  return (
    invoker: BugModalInvoker,
    errorTime: string,
    errorData?: ErrorData | ErrorData[]
  ): void => {
    const now = new Date().toISOString();

    const payload = {
      error: !errorData
        ? undefined
        : makeErrorEntity(invoker, errorData, errorTime),
      invoker,
      time: now,
    };
    dispatch(AC.invokeBugReportModal(payload));
  };
};

export const usePushErrorToStackCallback = (handledBy: BugModalInvoker) => {
  const dispatch = useDispatch();

  return (errorData: ErrorData | ErrorData[]) => {
    const entity = makeErrorEntity(handledBy, errorData);
    dispatch(AC.pushErrorToStack({ error: entity }));
  };
};

export const useRemoveErrorFromStackCallback = () => {
  const dispatch = useDispatch();

  return (index: number) => {
    dispatch(AC.removeErrorFromStack({ index }));
  };
};

export const useChangeBugReportMessageCallback = () => {
  const dispatch = useDispatch();

  return (newMsg: string) => {
    dispatch(AC.changeMessage({ message: newMsg }));
  };
};

export const useSubmitBugReport = () => {
  const dispatch = useDispatch();
  return (files: File[]) => dispatch(submitBugReport({ files }));
};
